import * as React from 'react';

export function CustomerSubscriptionsTab() {
  return <h1>Coming soon</h1>;
}
